// import external dependencies
import $ from 'jquery';

// Import everything from autoload
// import './autoload/**/*'
import 'bootstrap';
import 'jquery-match-height';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import TabbedCustomPostsLoops from './components/tabbed-custom-posts-loops';
import ToggleTabs from './components/toggle-tabs';
import PricingBlock from './components/pricing-block';
import StickyScroll from './util/StickyScroll';
import Amplitude from './components/amplitude';
import CustomPostsLoop from './components/custom-posts-loop';
import CTACardCarousel from './components/cta-card-carousel';
import Hubspot from './components/hubspot';
import ZoomInfo from './components/zoominfo';
import LogoGarden from './components/logo-garden';
import CustomerStories from './components/customer-stories';
import Accolades from './components/accolades';
import Marker from './components/marker';
import HubspotMulti from './components/hubspot-multi';
import Footer from './components/footer';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
$(function () {
  routes.loadEvents();
  Hubspot.init();
  ToggleTabs.init();
  TabbedCustomPostsLoops.init();
  PricingBlock.init();
  StickyScroll.init({
    offsets: [
      $('header.main-header'),
      $('#wpadminbar')
    ]
  });
  Amplitude.init();
  CustomPostsLoop.init();
  CTACardCarousel.init();
  ZoomInfo.init();
  LogoGarden.init();
  CustomerStories.init();
  Accolades.init();
  Marker.init();
  HubspotMulti.init();
  Footer.init();
});
